module.exports = __webpack_public_path__ + "img/39.24cbfa5a.jpg";